var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFilterSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9328 15.8917C11.9328 16.4 11.5995 17.0667 11.1745 17.325L9.99948 18.0834C8.90781 18.7584 7.39114 18 7.39114 16.65V12.1917C7.39114 11.6 7.05781 10.8417 6.71615 10.425L3.51612 7.05837C3.09112 6.63337 2.75781 5.88338 2.75781 5.37505V3.44171C2.75781 2.43338 3.51616 1.67505 4.44116 1.67505H15.5578C16.4828 1.67505 17.2411 2.43337 17.2411 3.35837V5.20837C17.2411 5.88337 16.8161 6.72505 16.3995 7.14171",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3913 13.7667C14.864 13.7667 16.058 12.5728 16.058 11.1C16.058 9.62727 14.864 8.43335 13.3913 8.43335C11.9185 8.43335 10.7246 9.62727 10.7246 11.1C10.7246 12.5728 11.9185 13.7667 13.3913 13.7667Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5579 14.2667L15.7246 13.4333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilterSearch);
export default __webpack_public_path__ + "static/media/ic-filter-search.44b5fde1ac9de5914580c9d54c605b29.svg";
export { ForwardRef as ReactComponent };